import React from "react";

const BuilderRow = ({ className, children }) => {
    return <div className={className + " flex"}>{children}</div>;
};

export default React.memo(BuilderRow);
